import { jsx as r, jsxs as s, Fragment as P } from "react/jsx-runtime";
import { Row as g, Col as C } from "antd";
import { memo as k, useState as b } from "react";
import { u as e } from "../../../styled-components.browser.esm-BFmoFexH.js";
import { d as x } from "../../../index-a388f2ac-Cf1pu7LW.js";
import { useHasPeriodApplied as R } from "../../../metricDisplay/MetricDisplay.hooks.js";
import { FlexMetricOptionRow as c, IconContainer as m, ContentCol as w, DeleteContainer as D } from "@biron-data/react-components";
import { F } from "../../../XCircleIcon-C46OdWM6.js";
import { E as M } from "../../../utils-wNl4DVdv.js";
import { MetricOptionsFormKeys as a } from "../options/MetricOptionForm.types.js";
import { useLanguageResolver as O } from "@biron-data/react-contexts";
const J = k(({
  value: i,
  setActiveKey: o,
  onDelete: n,
  iconSize: p,
  iconSpan: f
}) => {
  const l = O(), [h, d] = b(!1), u = R(i), t = M(o);
  return /* @__PURE__ */ r(j, { children: u && /* @__PURE__ */ r(L, { children: /* @__PURE__ */ r($, { children: /* @__PURE__ */ s(g, { children: [
    /* @__PURE__ */ r(C, { span: f, onClick: () => o == null ? void 0 : o(a.period), children: /* @__PURE__ */ r(c, { $clickable: t, children: /* @__PURE__ */ r(m, { size: p, children: /* @__PURE__ */ r(x.Date, {}) }) }) }),
    /* @__PURE__ */ r(w, { span: 19, onClick: () => o == null ? void 0 : o(a.period), children: /* @__PURE__ */ s(
      c,
      {
        $clickable: t,
        justify: "space-between",
        onMouseOver: () => d(!0),
        onMouseLeave: () => d(!1),
        children: [
          (i == null ? void 0 : i.overridePeriod) && /* @__PURE__ */ r(P, { children: `${l.get("configuration-metric-options.period.title")}: ${l.getTranslatedName(i.overridePeriod)}` }),
          h && n && /* @__PURE__ */ r(D, { children: /* @__PURE__ */ r(m, { clickable: !0, size: 14, color: "var(--light-grey)", children: /* @__PURE__ */ r(F, { onClick: () => n(["overridePeriod", "overridePeriodLabel"]) }) }) })
        ]
      }
    ) })
  ] }) }) }) });
}), $ = e.div`
  display: flex;
  flex-direction: column;
`, j = e.div`
  width: 100%;
  cursor: pointer;
`, L = e.div`
  align-items: center;
  gap: 10px;
`;
export {
  J as default
};
//# sourceMappingURL=MetricPeriodResume.js.map
